export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00250.c49c05cd.png";